import React, { useEffect, useState } from "react";
import { useNetwork } from "../../../context/NetworkContext";
import { useShowAlert } from "../../../context/AlertContext";
import AxiosInstance from "../../../utils/AxiosInstance";
import handleError from "../../../constants/handleError";
import { useAuth } from "../../../context/AuthProvider";
import { ErrorCircleIcon } from "../../../constants/Icons";
function ReportControl() {
  const [loading, setLoading] = useState(false);
  const { checkNetwork } = useNetwork();
  const { updateSettings } = useAuth();
  const showAlert = useShowAlert();

  const toggleItems = [
    {
      key: "ServiceDoneByReport",
      label: "Service Done By report",
      icon: "bx bx-user",
      settingLable: "isServiceDoneByReport",
      color: "gray",
      subtext:
        "Enable this option to display the Service Done By report section.",
    },
  ];
  const initialToggleState = toggleItems.reduce((acc, item) => {
    acc[item.key] = false;
    return acc;
  }, {});

  const [toggles, setToggles] = useState(initialToggleState);
  const handleUpdate = async (value, key, settingLable) => {
    setLoading((prev) => ({ ...prev, [key]: true }));
    try {
      if (!checkNetwork()) return;

      const data = {
        reportSettings: {
          [settingLable]: value,
        },
      };

      const response = await AxiosInstance.patch(`module/storesettings`, data);
      const savedSettings = response.data?.results?.reportSettings || {};
      if (Object.prototype.hasOwnProperty.call(savedSettings, settingLable)) {
      showAlert("success", response.data.message);
      updateSettings({
        storeSettings: {
          reportSettings: {
            [settingLable]: value,
          },
        },
      });
      setToggles((prev) => ({ ...prev, [key]: value }));}
    } catch (error) {
      handleError(error, showAlert);
    } finally {
      setLoading((prev) => ({ ...prev, [key]: false }));
    }
  };

  const handlelist = async () => {
    try {
      if (!checkNetwork()) return;

      const response = await AxiosInstance.get(`module/storesettings`);
      const reportSettings = response.data?.results?.reportSettings || {};

      const updatedToggles = {};
      toggleItems.forEach((item) => {
        updatedToggles[item.key] = reportSettings[item?.settingLable] || false;
      });

      setToggles(updatedToggles);
    } catch (error) {
      handleError(error, showAlert);
    }
  };

  const handleSwitchChange = (event, key, settingLable) => {
    const newValue = event.target.checked;
    handleUpdate(newValue, key, settingLable);
  };

  useEffect(() => {
    handlelist();
  }, []);

  return (
    <>
      <div className="row">
        <div className="col-lg-5">
          <div className="card">
            <div className="card-header p-3 bg-light-core">
              <h6 className="mb-0 text-dark">Report Settings</h6>
            </div>
            <div className="card-body">
              <div className="row align-items-center">
                <div className="col-lg-12">
                  {toggleItems.map(
                    ({ key, label, icon, color, settingLable, subtext }) => (
                      <div key={key} className="d-flex align-items-center">
                        <div>
                          <i
                            className={`${icon} font-27`}
                            style={{ color: toggles[key] ? color : "gray" }}
                          ></i>
                        </div>
                        <div className="flex-grow-1 ms-2">
                          <label className="mb-0">
                            {label}
                            <span className="tooltip-container ms-1">
                              <span className="cursor-poInter">
                                <ErrorCircleIcon/>{" "}
                              </span>
                              <span
                                className="tooltip-text"
                                style={{ zIndex: 10 }}
                              >
                                {subtext}
                              </span>
                            </span>
                          </label>
                        </div>
                        <div className="ms-auto custom-toggle-wrapper">
                          <label className="custom-toggle">
                            <input
                              type="checkbox"
                              id={`${key}Toggle`}
                              checked={toggles[key]}
                              onChange={(event) =>
                                handleSwitchChange(event, key, settingLable)
                              }
                              disabled={loading[key]}
                            />
                            <span className="slider cursor-poInter">
                              {loading[key] ? (
                                <span
                                  className={`spinner-inside ${
                                    toggles[key] ? "spinner-right" : ""
                                  }`}
                                />
                              ) : (
                                <>
                                  {toggles[key] ? (
                                    <span className="label-on ms-0-1">ON</span>
                                  ) : (
                                    <span className="label-off ms-3">OFF</span>
                                  )}
                                </>
                              )}
                            </span>
                          </label>
                        </div>
                      </div>
                    ),
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ReportControl;
